import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

var vUI_Workflow_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_WORKFLOW_ID:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Workflow WB Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    WORKFLOW_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Workflow Id', columnResourceName: 'colWorkflowId', alignment: HorizAlignment.Right}, domainOptions: { maxLength: 50}},
    WORKFLOW_NAME:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}}
}

var WorkflowSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_WORKFLOW_ID',
        id_ui: 'WORKFLOW_ID',
        name:  'WORKFLOW_NAME'},


    searchProviderFields: vUI_Workflow_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Workflow_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


var WorkflowSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "WorkflowSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'WORKFLOW_ID', renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'WORKFLOW_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'WORKFLOW_ID','WORKFLOW_NAME'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: WorkflowSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

var WorkflowSearch: ISearch = {
    searchName: "Find Workflow",
    renderOptions: { ui5ResourceId: "WorkflowSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [WorkflowSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("WorkflowBO", "Workflow", WorkflowSearch, "Workflow Search")

export {WorkflowSearch}